const dictionaryActions = {
  ADD_DATASET_DICTIONARY_UPLOAD_MESSAGE: 'ADD_DATASET_DICTIONARY_UPLOAD_MESSAGE',
  ADD_DICTIONARY_FIELD: 'ADD_DICTIONARY_FIELD',
  ADD_LOOKUP_ITEM: 'ADD_LOOKUP_ITEM',
  APPLY_DICTIONARIES: 'APPLY_DICTIONARIES',
  COPY_DICTIONARY_FIELD: 'COPY_DICTIONARY_FIELD',
  DATASET_DICTIONARY_UPLOAD: 'DATASET_DICTIONARY_UPLOAD',
  DATASET_DICTIONARY_UPLOAD_FAIL: 'DATASET_DICTIONARY_UPLOAD_FAIL',
  DATASET_DICTIONARY_UPLOAD_SUCCESS: 'DATASET_DICTIONARY_UPLOAD_SUCCESS',
  DELETE_ACTIVE_DICTIONARY: 'DELETE_ACTIVE_DICTIONARY',
  DELETE_ACTIVE_LOOKUP: 'DELETE_ACTIVE_LOOKUP',
  DELETE_DICTIONARY_FIELD: 'DELETE_DICTIONARY_FIELD',
  DELETE_LOOKUP_ITEM: 'DELETE_LOOKUP_ITEM',
  DOWNLOAD_DICTIONARIES: 'DOWNLOAD_DICTIONARIES',
  DOWNLOAD_DICTIONARIES_ERROR: 'DOWNLOAD_DICTIONARIES_ERROR',
  HIDE_DICTIONARY_FIELD: 'HIDE_DICTIONARY_FIELD',
  HIDE_DICTIONARY_LOOKUPS: 'HIDE_DICTIONARY_LOOKUPS',
  HIDE_EDIT_ACTIVE_LOOKUP: 'HIDE_EDIT_ACTIVE_LOOKUP',
  HIDE_EDIT_DICTIONARY: 'HIDE_EDIT_DICTIONARY',
  INSERT_ACTIVE_DICTIONARY: 'INSERT_ACTIVE_DICTIONARY',
  REMOVE_DATASET_DICTIONARY_FILE_UPLOAD: 'REMOVE_DATASET_DICTIONARY_FILE_UPLOAD',
  SHOW_DICTIONARY_FIELD: 'SHOW_DICTIONARY_FIELD',
  SHOW_DICTIONARY_LOOKUPS: 'SHOW_DICTIONARY_LOOKUPS',
  SHOW_EDIT_ACTIVE_LOOKUP: 'SHOW_EDIT_ACTIVE_LOOKUP',
  SHOW_EDIT_DICTIONARY: 'SHOW_EDIT_DICTIONARY',
  TOGGLE_DICTIONARY_FIELDS_PROPERTY: 'TOGGLE_DICTIONARY_FIELDS_PROPERTY',
  UPDATE_ACTIVE_DICTIONARY: 'UPDATE_ACTIVE_DICTIONARY',
  UPDATE_ACTIVE_DICTIONARY_EDIT: 'UPDATE_ACTIVE_DICTIONARY_EDIT',
  UPDATE_ACTIVE_FIELD: 'UPDATE_ACTIVE_FIELD',
  UPDATE_ACTIVE_LOOKUP: 'UPDATE_ACTIVE_LOOKUP',
  UPDATE_ACTIVE_LOOKUP_PROPERTIES: 'UPDATE_ACTIVE_LOOKUP_PROPERTIES',
  UPDATE_ACTIVE_LOOKUP_TYPE: 'UPDATE_ACTIVE_LOOKUP_TYPE',
  UPDATE_DICTIONARY_FIELD_TYPE: 'UPDATE_DICTIONARY_FIELD_TYPE',
  UPDATE_DICTIONARY_FIELDS: 'UPDATE_DICTIONARY_FIELDS',
  UPDATE_DICTIONARY_PROPERTIES: 'UPDATE_DICTIONARY_PROPERTIES',
  UPDATE_LOOKUP_ITEM_PROPERTIES: 'UPDATE_LOOKUP_ITEM_PROPERTIES',
  UPDATE_LOOKUP_PROPERTIES: 'UPDATE_LOOKUP_PROPERTIES',
};

export default dictionaryActions;
